import { ICommunityEngagementStore } from './types';

const initStore: ICommunityEngagementStore = {
  monthlyRecord: null,
  exemptionCategories: [],
  isExpansionPlan: false,
};

export default initStore;
